import { useEffect } from "react";
import { useAuth } from "@/lib/auth";

/* Renommage global par tenant (ex. Corner → Magasin, Wasaplan → Compte de résultat) : textes visibles, attributs (placeholder, title, aria-label, alt, value des boutons), titre d'onglet.
   S'applique à tout le DOM (menus, tableaux, graphiques SVG, modales, toasts) et suit toutes les mutations React. */
const ATTRS = ["placeholder", "title", "aria-label", "alt", "data-label"];
const SKIP = new Set(["SCRIPT", "STYLE", "TEXTAREA", "CODE", "NOSCRIPT"]);

export function TerminologyObserver() {
  const { user } = useAuth();
  const terms = user?.tenant?.terminology;
  useEffect(() => {
    if (!terms || !Object.keys(terms).length) return;
    const keys = Object.keys(terms).sort((a, b) => b.length - a.length);
    const re = new RegExp(`(${keys.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})`, "g");
    const has = s => { re.lastIndex = 0; return re.test(s); };
    const fix = s => s.replace(re, m => terms[m]);
    const fixEl = el => {
      if (!el || el.nodeType !== 1) return;
      ATTRS.forEach(a => { const v = el.getAttribute(a); if (v && has(v)) el.setAttribute(a, fix(v)); });
      if ((el.tagName === "INPUT" && ["button", "submit"].includes(el.type)) && has(el.value)) el.value = fix(el.value);
    };
    const walk = root => {
      if (root.nodeType === 3) { if (root.parentNode && !SKIP.has(root.parentNode.nodeName) && has(root.nodeValue)) root.nodeValue = fix(root.nodeValue); return; }
      if (root.nodeType !== 1 || SKIP.has(root.nodeName)) return;
      const it = document.createNodeIterator(root, NodeFilter.SHOW_TEXT);
      let n; while ((n = it.nextNode())) { if (n.parentNode && !SKIP.has(n.parentNode.nodeName) && has(n.nodeValue)) n.nodeValue = fix(n.nodeValue); }
      fixEl(root); root.querySelectorAll(ATTRS.map(a => `[${a}]`).join(",") + ",input[type=button],input[type=submit]").forEach(fixEl);
    };
    const run = () => { walk(document.body); if (has(document.title)) document.title = fix(document.title); };
    let obs;
    const observe = () => obs.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
    obs = new MutationObserver(muts => {
      obs.disconnect();
      muts.forEach(m => {
        if (m.type === "characterData") { if (has(m.target.nodeValue)) m.target.nodeValue = fix(m.target.nodeValue); }
        else if (m.type === "attributes") fixEl(m.target);
        else m.addedNodes.forEach(walk);
      });
      if (has(document.title)) document.title = fix(document.title);
      observe();
    });
    run(); observe();
    const iv = setInterval(run, 2000); // filet de sécurité (portails, canvas → svg re-rendus)
    return () => { obs.disconnect(); clearInterval(iv); };
  }, [terms]);
  return null;
}
